import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';
import { ImageResizeOptions, WowImage } from 'wix-ui-tpa/cssVars';

import { useWidget } from '../../../../../../../contexts/widgets';
import { DataHook } from '../../../../../../../types';
import styles from './CoverImage.scss';

const DEFAULT_FOCAL_POINT = 50;

export const CoverImage: FC = () => {
  const { computed, profilePage } = useWidget();

  const { isCoverRepositionMode, isCoverLoading } = profilePage;
  const {
    horizontalProfileCoverPhotoStyle,
    horizontalProfileCoverPhoto,
    profileWidgetHeight,
    isDesignBackgroundsAndBordersPreview,
    defaultCoverUrl,
  } = computed;

  const coverUrl =
    isDesignBackgroundsAndBordersPreview && defaultCoverUrl
      ? defaultCoverUrl
      : horizontalProfileCoverPhoto?.src;

  const showWowImage =
    !isCoverRepositionMode && horizontalProfileCoverPhoto?.src;

  if (showWowImage) {
    return (
      <WowImage
        data-hook={DataHook.HighQualityCover}
        className={styles.coverImage}
        src={coverUrl ?? ''}
        resize={ImageResizeOptions.cover}
        focalPoint={{
          x: horizontalProfileCoverPhoto?.position.x ?? DEFAULT_FOCAL_POINT,
          y: horizontalProfileCoverPhoto?.position.y ?? DEFAULT_FOCAL_POINT,
        }}
        sourceHeight={profileWidgetHeight}
        sourceWidth={horizontalProfileCoverPhoto?.imageProps.rw}
        aspectRatio="cinema"
        fluid
        shouldUseLQIP
        encoding={computed.isAvifEncodingEnabled ? 'AVIF' : undefined}
      />
    );
  }

  return (
    <div
      className={isCoverRepositionMode ? styles.coverRepositionModeOverlay : ''}
    >
      <div
        data-hook={DataHook.HighQualityCover}
        className={classNames(
          styles.cover,
          isCoverLoading && styles.coverIsLoading,
          !horizontalProfileCoverPhotoStyle && styles.withCoverColor,
        )}
        style={horizontalProfileCoverPhotoStyle || {}}
      />
    </div>
  );
};
